import { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  /** Imported PNG URL for the leading icon. */
  iconSrc: string;
  iconAlt: string;
}>;

const FilterGroup = ({ iconSrc, iconAlt, children }: Props) => (
  <div className="filter-group" role="group" aria-label={iconAlt}>
    <div className="filter-group-icon" aria-hidden>
      <img src={iconSrc} alt={iconAlt} />
    </div>
    {children}
  </div>
);

export default FilterGroup;
